export default __webpack_public_path__ + "static/media/rabbit-purple.fbd6cdd8.svg";